import { render, staticRenderFns } from "./RTopSentimentReviewCards.vue?vue&type=template&id=29b4b227&scoped=true&"
import script from "./RTopSentimentReviewCards.vue?vue&type=script&lang=js&"
export * from "./RTopSentimentReviewCards.vue?vue&type=script&lang=js&"
import style0 from "./RTopSentimentReviewCards.vue?vue&type=style&index=0&id=29b4b227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b4b227",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
